<template>
	<div class="auth-page">
		<div class="auth-card" v-if="!register">
			<div class="auth-logo">
				<img v-if="name.startsWith('http')" :src="name" alt="logo" />
				<span v-else class="logo-fallback">{{ name }}</span>
			</div>
			<div class="auth-badge"><i class="fas fa-lock"></i></div>
			<h1 class="auth-title">Connexion</h1>
			<p class="auth-subtitle">Connectez-vous pour accéder à votre espace</p>

			<b-form class="auth-form" @submit="onSubmit">
				<div class="auth-field">
					<label for="user">{{ label_login }}</label>
					<b-form-input
						id="user"
						class="auth-input"
						type="text"
						v-model="form.user"
						required
						autofocus
						placeholder="Identifiant"></b-form-input>
				</div>
				<div class="auth-field">
					<label for="pwd">Mot de passe</label>
					<b-input-group>
						<b-form-input
							id="pwd"
							class="auth-input"
							:type="showPassword ? 'text' : 'password'"
							v-model="form.pwd"
							required
							placeholder="Mot de passe"></b-form-input>
						<template #append>
							<b-button
								variant="outline-secondary"
								tabindex="-1"
								@click="showPassword = !showPassword">
								<i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
							</b-button>
						</template>
					</b-input-group>
				</div>

				<b-button type="submit" class="auth-submit" variant="primary">Valider</b-button>
			</b-form>

			<b-alert class="auth-alert" v-if="error" show variant="danger">{{ errorMsg }}</b-alert>

			<div class="auth-links">
				<a href="/password_reset">Mot de passe oublié ?</a>
			</div>

			<div class="auth-footer" v-if="register_page">
				Pas encore de compte ?
				<b-button class="auth-link-btn" @click="register = true" variant="link">Créer un compte</b-button>
			</div>
		</div>
		<div class="auth-card auth-card--wide" v-else>
			<register :login="true" :_token="register_page_token" @register="register = false"></register>
			<div class="auth-footer">
				<b-button class="auth-link-btn" @click="register = false" variant="link">Se connecter à un compte déjà existant.</b-button>
			</div>
		</div>
	</div>
</template>

<script>
	import login from "../services/login.js";
	import users from "../services/users.js";
	import register from "./Register.vue";
	import store from "../store";

	export default {
		name: "login",
		components: {
			register
		},
		data() {
			return {
				register: false,
				label_login: process.env.VUE_APP_LABEL_LOGIN || "Votre identifiant",
				register_page: process.env.VUE_APP_REGISTER,
				register_page_token: process.env.VUE_APP_REGISTER_TOKEN,
				form: {
					user: "",
					pwd: "",
				},
				error: false,
				errorMsg: null,
				name: process.env.VUE_APP_NAME || "Smartmydata",
				showPassword: false,
			};
		},
		methods: {
			onSubmit(evt) {
				evt.preventDefault();
				login
					.auth(this.form.user, this.form.pwd)
					.then(async (res) => {
						let jwt = res.data.jwt;
						this.$store.commit("setJwt", jwt);

						var response = await users.getSelf(true);
						this.$store.commit("setUser", response.user);
						this.$store.commit("setAdminSession", false);

						this.$emit("loginSuccess");
						this.$router.push({ name: "main" });
					})
					.catch((error) => {

						console.log("login failed")
						console.log(error.response.data.msg)
						
						this.error = true;

						if (error.response.data.msg == "User found but archived.")
							this.errorMsg = "Le compte n'est pas actif. Un mail vous a été envoyé pour l'activer lors de l'inscription."
						else
							this.errorMsg = "L'email et/ou le mot de passe sont invalides.";
					});
			},
		},
	};
</script>

